/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 11/11/21
 */

import { withDisplayName } from '@/utils/withDisplayName';
import {
    withJsonFormsArrayControlProps,
    withJsonFormsArrayLayoutProps,
    withJsonFormsCellProps,
    withJsonFormsControlProps,
    withJsonFormsEnumCellProps,
    withJsonFormsEnumProps,
    withJsonFormsLayoutProps,
    withJsonFormsOneOfEnumProps,
} from '@jsonforms/react';

export const withNamedJsonFormsCellProps = (...args: Parameters<typeof withJsonFormsCellProps>) =>
    withDisplayName(withJsonFormsCellProps(...args), 'withJsonFormsCellProps');

export const withNamedJsonFormsEnumCellProps = (...args: Parameters<typeof withJsonFormsEnumCellProps>) =>
    withDisplayName(withJsonFormsEnumCellProps(...args), 'withJsonFormsEnumCellProps');

export const withNamedJsonFormsLayoutProps = (...args: Parameters<typeof withJsonFormsLayoutProps>) =>
    withDisplayName(withJsonFormsLayoutProps(...args), 'withJsonFormsLayoutProps');

export const withNamedJsonFormsControlProps = (...args: Parameters<typeof withJsonFormsControlProps>) =>
    withDisplayName(withJsonFormsControlProps(...args), 'withJsonFormsControlProps');

export const withNamedJsonFormsEnumProps = (...args: Parameters<typeof withJsonFormsEnumProps>) =>
    withDisplayName(withJsonFormsEnumProps(...args), 'withJsonFormsEnumProps');

export const withNamedJsonFormsOneOfEnumProps = (...args: Parameters<typeof withJsonFormsOneOfEnumProps>) =>
    withDisplayName(withJsonFormsOneOfEnumProps(...args), 'withJsonFormsOneOfEnumProps');

export const withNamedJsonFormsArrayControlProps = (...args: Parameters<typeof withJsonFormsArrayControlProps>) =>
    withDisplayName(withJsonFormsArrayControlProps(...args), 'withJsonFormsArrayControlProps');

export const withNamedJsonFormsArrayLayoutProps = (...args: Parameters<typeof withJsonFormsArrayLayoutProps>) =>
    withDisplayName(withJsonFormsArrayLayoutProps(...args), 'withJsonFormsArrayLayoutProps');
